module.exports = __webpack_public_path__ + "img/info-text-panel-icon.0c28d0f5.svg";